(function waitForAvailabilityData(callback, retries = 20) {
  const dataEl = document.getElementById('VariantAvailabilityData');
  if (dataEl) {
    try {
      const parsed = JSON.parse(dataEl.textContent);
      window.variantAvailabilityData = parsed;
      console.log('[availability] Parsed JSON from VariantAvailabilityData:', parsed);
      callback(parsed);
    } catch (e) {
      console.error('[availability] Failed to parse VariantAvailabilityData JSON', e);
      callback(null);
    }
  } else if (retries > 0) {
    setTimeout(() => waitForAvailabilityData(callback, retries - 1), 150);
  } else {
    console.warn('[availability] VariantAvailabilityData not found after retries');
    callback(null);
  }
})(function initAvailability(parsed) {
  if (!parsed) return;

  window.productHandle = window.productHandle || ShopifyAnalytics?.meta?.product?.handle || '';

  window.iconVGUrl = window.iconVGUrl || '';
  window.iconArchUrl = window.iconArchUrl || '';
  window.iconMapPinUrl = window.iconMapPinUrl || '';
  window.iconPlainUrl = window.iconPlainUrl || '';
  window.iconDeliveryUrl = window.iconDeliveryUrl || '';

  function getAvailabilityContainer(sectionId) {
    const id = `product-availability-${sectionId || ShopifyAnalytics?.meta?.page?.pageType || 'product'}`;
    return document.getElementById(id);
  }

  function updateAvailabilityContainer(container, html) {
    if (container) {
      container.innerHTML = html || '';
      container.style.display = html ? '' : 'none';
    }
  }

  function iconHTML(name) {
    const urls = {
      'vg': window.iconVGUrl,
      'arkh': window.iconArchUrl,
      'map-pin': window.iconMapPinUrl,
      'plain': window.iconPlainUrl,
      'delivery': window.iconDeliveryUrl
    };
    if (name === 'box') return '<!-- HTML иконки box -->';
    return urls[name] ? `<img src="${urls[name]}" alt="${name} Icon">` : '';
  }

  function renderAvailabilityHTML(data) {
    const { _Arkhangelskoe, _CB, _VG, _US } = data;
    const flags = {
      Arkhangelskoe: _Arkhangelskoe && _Arkhangelskoe != 0,
      CB: _CB && _CB != 0,
      VG: _VG && _VG != 0,
      US: _US && _US != 0
    };

    if (flags.Arkhangelskoe || flags.CB || flags.VG || flags.US) {
      let html = '<p class="caption-large availability-block-title">Товар в наличии:</p>';
      if (flags.VG) html += `
        <availability-block-preview class="availability-block-preview">
          ${iconHTML('vg')}
          <div class="availability-block-info">
            <p class="caption-large">В Sortage. Времена Года</p>
          </div>
        </availability-block-preview>`;
      if (flags.Arkhangelskoe) html += `
        <availability-block-preview class="availability-block-preview">
          ${iconHTML('arkh')}
          <div class="availability-block-info">
            <p class="caption-large">В Sortage. Архангельское</p>
          </div>
        </availability-block-preview>`;
      if (flags.CB) html += `
        <availability-block-preview class="availability-block-preview">
          ${iconHTML('map-pin')}
          <div class="availability-block-info">
            <p class="caption-large">На складе в Москве</p>
          </div>
        </availability-block-preview>`;
      if (flags.US) html += `
        <availability-block-preview class="availability-block-preview">
          ${iconHTML('box')}
          <div class="availability-block-info">
            <p class="caption-large">На удаленном складе</p>
          </div>
        </availability-block-preview>`;
      return html;
    } else {
      return `
        <p class="caption-large availability-order-title">Товар доступен под заказ:</p>
        <availability-block-preview class="availability-block-preview">
          ${iconHTML('plain')}
          <div class="availability-block-info">
            <p class="caption-large">Авиа-экспресс: 8 рабочих дней</p>
          </div>
        </availability-block-preview>
        <availability-block-preview class="availability-block-preview">
          ${iconHTML('delivery')}
          <div class="availability-block-info">
            <p class="caption-large">Под заказ: 15-20 рабочих дней</p>
          </div>
        </availability-block-preview>`;
    }
  }

  function handleVariantChange(variant) {
    if (!variant || !window.productHandle) return;
    const key = `${window.productHandle}_${variant.id}`;
    const container = getAvailabilityContainer(variant?.sectionId);
    updateAvailabilityContainer(container, '');
    const data = window.variantAvailabilityData[key];
    const html = data ? renderAvailabilityHTML(data) : '';
    updateAvailabilityContainer(container, html);
  }

  if (typeof subscribe === 'function' && PUB_SUB_EVENTS?.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { variant } }) => {
      try {
        handleVariantChange(variant);
      } catch (e) {
        console.error('Error updating availability:', e);
        updateAvailabilityContainer(getAvailabilityContainer(), '');
      }
    });
  } else {
    const defaultId = ShopifyAnalytics?.meta?.selectedVariantId || product?.selected_or_first_available_variant?.id;
    const handle = window.productHandle;
    if (defaultId && handle) {
      const key = `${handle}_${defaultId}`;
      const container = getAvailabilityContainer();
      const data = window.variantAvailabilityData[key];
      const html = data ? renderAvailabilityHTML(data) : '';
      updateAvailabilityContainer(container, html);
    }
  }
});
